import { useEffect } from "react";

interface PageMetaProps {
  title: string;
  description: string;
  keywords?: string;
  noindex?: boolean;
}

export default function PageMeta({ title, description, keywords, noindex = false }: PageMetaProps) {
  useEffect(() => {
    document.title = title;

    const ensure = (selector: string, create: () => HTMLMetaElement) => {
      let el = document.head.querySelector<HTMLMetaElement>(selector);
      if (!el) {
        el = create();
        document.head.appendChild(el);
      }
      return el;
    };

    const desc = ensure('meta[name="description"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "description");
      return m;
    });
    desc.setAttribute("content", description);

    if (keywords) {
      const kw = ensure('meta[name="keywords"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "keywords");
        return m;
      });
      kw.setAttribute("content", keywords);
    }

    let robots = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex,follow");
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, keywords, noindex]);

  return null;
}